import type { QueryClient } from '@tanstack/react-query'
import { redirect } from '@tanstack/react-router'

import { authQueryOptions } from '#hooks/use-auth'
import { posthog } from '#lib/posthog'
import { useWaiterStore } from '#stores/use-waiter-store'

const WAITER_TOKEN_KEY = '@usecomanda:waiter_token'

export async function requireOperationalWorkspace(queryClient: QueryClient) {
  const token = localStorage.getItem(WAITER_TOKEN_KEY)
  const member = useWaiterStore.getState().waiter

  if (token && (!member || member.is_active === false)) {
    localStorage.removeItem(WAITER_TOKEN_KEY)
    posthog.reset()
    useWaiterStore.getState().clearWaiter()
    throw redirect({ to: '/garcom' })
  }

  if (token && member?.role === 'kitchen') {
    throw redirect({ to: '/cozinha' })
  }

  if (token && member?.role === 'waiter') return

  const authData = await queryClient.ensureQueryData(authQueryOptions)
  if (authData.user && !authData.tenant_id) {
    throw redirect({ to: '/onboarding' })
  }
  if (authData.user && authData.role === 'admin' && authData.tenant_id) return

  throw redirect({
    to: '/login',
    search: { redirect: window.location.href },
  })
}
